<script setup lang="ts">
    import type { StoryblokComponent } from '@storyblok/vue';

    const props = defineProps<{
        blok: unknown;
    }>();

    const blok = computed(() => props.blok as (typeof StoryblokComponent)['props']['blok']);
</script>

<template>
    <StoryblokComponent :blok="blok" />
</template>
